<template>
  <ProfileAndCourses :teacher-id="teacherId" />
</template>
<script>

import ProfileAndCourses from 'components/teacher/ProfileAndCourses/index.vue'

export default {
  components: {
    ProfileAndCourses,
  },
  computed: {
    teacherId() {
      return this.$route.params.teacherId
    },
  },
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 1440px;
  padding: 20px 48px  133px 48px;
  margin: 40px auto;
  background: rgba(244, 246, 250, 1);
  border-radius: 10px;
  .card_wrap { padding-left: 367px; }

  .tab {
    /deep/.el-tabs {
      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__header {
        height: 50px;
        margin: 0 0 40px;
      }

      .el-tabs__nav-wrap,
      .el-tabs__nav-scroll { overflow: visible; }
      .el-tabs__active-bar { display: none; }

      .el-tabs__item {
        font-size: 32px;
        font-weight: 600;
        outline: none !important;
        color: var(--txt-color-lv2);

        &.is-active {
          color: rgba(23, 43, 77, 1);

          &::after {
            display: block;
            content: '';
            height: 3px;
            width: 32px;
            background: var(--txt-color-link);
            margin: 0 auto;
          }
        }
      }

      .title {
        font-size: 32px;
        font-weight: 600;
        color: rgba(23, 43, 77, 1);
        line-height: 38px;
        margin-bottom: 24px;
      }
      ul { margin-bottom: 120px; }

      ul > li,
      p {
        font-size: 20px;
        font-weight: 500;
        color: rgba(69, 85, 113, 1);
        line-height: 28px;
      }
    }
  }
}
</style>
